export enum Gender {
  MALE = 'm',
  FEMALE = 'f',
}

export enum Background {
  SAGE = 'Sage',
  STONE = 'Stone',
  CLASSIC = 'Classic',
  MANILA = 'Manila',
  BREEZE = 'Breeze',
  DARK_PURPLE = 'Dark Purple',
  CREAM = 'Cream',
  MATCHSTICK = 'Matchstick',
  ZEN = 'Zen',
  DARK_BLUE = 'Dark Blue',
  BEIGE_BRULEE = 'Beige Brulee',
  VIVID = 'Vivid',
  CORPORATE = 'Corporate',
  IVORY = 'Ivory',
  PERSONA = 'Persona',
  SAND = 'Sand',
}

export enum Clothing {
  OVERALLS = 'Overalls',
  DENIM_JACKET = 'Denim Jacket',
  DENIM_HOODIE = 'Denim Hoodie',
  PATTERNED_SHIRT = 'Patterned Shirt',
  PATCHWORK_SHIRT = 'Patchwork Shirt',
  BASEBALL_JERSEY = 'Baseball Jersey',
  RITSUKO_VEST = 'Ritsuko Vest',
  CLASSY_SHIRT = 'Classy Shirt',
  BANANA_GUNNERS = 'Banana Gunners',
  BASKETBALL_JERSEY = 'Basketball Jersey',
  KIMONO_GIRL = 'Kimono Girl',
  PRISMATIC_BOMBER = 'Prismatic Bomber',
  TIE_DYE = 'Tie Dye',
  VARSITY_JACKET = 'Varsity Jacket',
  OVERSIZED_HOODIE = 'Oversized Hoodie',
  LUMBERJACK_SHIRT = 'Lumberjack Shirt',
  BLUE_SWEATER = 'Blue Sweater',
  MECHA = 'Mecha',
  DINER_SHIRT = 'Diner Shirt',
  NYC_JERSEY = 'NYC Jersey',
  CORDUROY_SHIRT = 'Corduroy Shirt',
  SPORT_HOODIE = 'Sport Hoodie',
  ARCADE_VEST = 'Arcade Vest',
  MOTORCYCLE_JACKET = 'Motorcycle Jacket',
  TURTLENECK = 'TurtleNeck',
  GOLF_SHIRT = 'Golf Shirt',
  TRAINING_TANK = 'Training Tank',
  LENDERS_JERSEY = 'Lenders Jersey',
  COLLARED_JACKET = 'Collared Jacket',
  SCHOOL_UNIFORM = 'School Uniform',
  RACING_JACKET = 'Racing Jacket',
  POLO = 'Polo',
  PRISMATIC_TURTLENECK = 'Prismatic Turtleneck',
  QIPAO = 'QiPao',
  TSUBASA_JERSEY = 'Tsubasa Jersey',
  PRISMATIC_CYBER = 'Prismatic Cyber',
  CUBIST_NAVY_SHIRT = 'Cubist Navy Shirt',
  PERSONA_JACKET = 'Persona Jacket',
  ROCK_TSHIRT = 'Rock T-shirt',
  GOHAN = 'Gohan',
  BOMBER_COAT = 'Bomber Coat',
  CLASSY_SUIT = 'Classy Suit',
  CLASSY_BOMBER = 'Classy Bomber',
  KIMONO_BOY = 'Kimono Boy',
  BLAUGRANA_JERSEY = 'Blaugrana Jersey',
  HAWAIIAN_SHIRT = 'Hawaiian Shirt',
  YUSUKE = 'Yusuke',
  FUTURE_TRUNKS = 'Future Trunks',
  SKI_JACKET = 'Ski Jacket',
  TRACK_JACKET = 'Track Jacket',
  PATTERNED_BOMBER = 'Patterned Bomber',
  RED_COAT = 'Red Coat',
  MISATO_TOP = 'Misato Top',
  ARCADE_HOODIE = 'Arcade Hoodie',
  MISATO_JACKET = 'Misato Jacket',
  FUR_BOMBER = 'Fur Bomber',
  FLOWER_COAT = 'Flower Coat',
  SIMPLE_BLAZER = 'Simple Blazer',
  SPIKE = 'Spike',
  GM = 'GM',
  FAYE = 'Faye',
  ARCADE_PACMAN = 'Arcade Pacman',
  COLOR_BLOCK_HOODIE = 'Color Block Hoodie',
  NERV_SUIT = 'NERV suit',
  ASHITAKA = 'Ashitaka',
  RETRO_BLOCK_SHIRT = 'Retro Block Shirt',
  TIME_COAT = 'Time Coat',
  TRADITIONAL_OUTFIT = 'Traditional Outfit',
  VALLEY_AVIATOR = 'Valley Aviator',
  PATTERNED_SWEATER = 'Patterned Sweater',
  DIGITAL_HOODIE = 'Digital Hoodie',
  SWEATER_ON_SHOULDERS = 'Sweater on Shoulders',
  PARIS_JERSEY = 'Paris Jersey',
  CAPSULE_JACKET = 'Capsule Jacket',
  YUSUKE_RED = 'Yusuke Red',
  PRISMATIC_VARSITY_JACKET = 'Prismatic Varsity Jacket',
  PRISMATIC_TRACK_JACKET = 'Prismatic Track Jacket',
}

export enum Eyes {
  CHILL = 'Chill',
  NOSTALGIC = 'Nostalgic',
  JOYFUL = 'Joyful',
  THOUGHTFUL = 'Thoughtful',
  TEARY = 'Teary',
  CHEERS = 'Cheers',
  NEUTRAL = 'Neutral',
  CLOSED = 'Closed',
  PLEASANT = 'Pleasant',
  DAYDREAM = 'Daydream',
  BORED = 'Bored',
  INDIFFERENT = 'Indifferent',
  WINK = 'Wink',
  PRISMATIC = 'Prismatic',
  SMUG = 'Smug',
  RELAXED = 'Relaxed',
  SUSPICIOUS = 'Suspicious',
  FIERCE = 'Fierce',
  TIME_MAGIC = 'Time Magic',
  VALIANT = 'Valiant',
  CONFUSED = 'Confused',
  PENSIVE = 'Pensive',
  DEMON_EYES = 'Demon Eyes',
  SOLARIS = 'Solaris',
  ARCADE = 'Arcade',
}

export enum Haircuts {
  MESSY_BUN = 'Messy Bun',
  GREASER = 'Greaser',
  BOWL = 'Bowl',
  MOODY = 'Moody',
  FLUFFY = 'Fluffy',
  HANNAH = 'Hannah',
  SPIKY_PONEY = 'Spiky Poney',
  WINDY_SAMURAI = 'Windy Samurai',
  FLOWY = 'Flowy',
  PIGTAILS = 'Pigtails',
  SHORT = 'Short',
  CURLY_BOB = 'Curly Bob',
  TIME_MAGIC_FLOWY = 'Time Magic Flowy',
  TIME_MAGIC_FADED = 'Time Magic Faded',
  FLUFFY_CURLS = 'Fluffy Curls',
  SAMURAI = 'Samurai',
  WINDY_PIXIE = 'Windy Pixie',
  DREADS = 'Dreads',
  RETRO_CUT = 'Retro Cut',
  SILKY = 'Silky',
  MULLET = 'Mullet',
  STRAIGHT_LONG = 'Straight Long',
  SHAGGY = 'Shaggy',
  WAVY_UNDERCUT = 'Wavy Undercut',
  WAVY = 'Wavy',
  FADED = 'Faded',
  STRAIGHT_BOB = 'Straight Bob',
  HIME = 'Hime',
  PRISMATIC_BUN = 'Prismatic Bun',
  TIME_MAGIC_PIXIE = 'Time Magic Pixie',
  HALF_BUN = 'Half Bun',
  SPIKE = 'Spike',
  AFRO_GIRL = 'Afro Girl',
  SCRUFFY = 'Scruffy',
  TIME_MAGIC_FLUFFY = 'Time Magic Fluffy',
  PIXIE = 'Pixie',
  PRISMATIC_FLUFFY = 'Prismatic Fluffy',
  COIL_DREADS = 'Coil Dreads',
  BRAIDS = 'Braids',
  BALD = 'Bald',
  PRISMATIC_HANNAH = 'Prismatic Hannah',
  PRISMATIC_SHAGGY = 'Prismatic Shaggy',
  TIME_MAGIC_SAMURAI = 'Time Magic Samurai',
}

export enum Mouth {
  POUT = 'Pout',
  YUMMY = 'Yummy',
  LIP_PIERCING = 'Lip Piercing',
  RELAXED = 'Relaxed',
  GUITAR_PICK = 'Guitar Pick',
  GRIT = 'Grit',
  SMILE = 'Smile',
  UPSET = 'Upset',
  GROWL = 'Growl',
  TALKING = 'Talking',
  LAUGHING = 'Laughing',
  LOLLIPOP = 'Lolipop',
  CIGARETTE = 'Cigarette',
  CHEWING = 'Chewing',
  PARTY_HORN = 'Party Horn',
  POCKY = 'Pocky',
  PRISMATIC_BUBBLEGUM = 'Prismatic Bubblegum',
  NEUTRAL = 'Neutral',
  TOOTHPICK = 'Toothpick',
  TEASE = 'Tease',
  BUBBLEGUM = 'Bubblegum',
}

export enum Type {
  HUMAN = 'Human',
  RUNIC = 'Runic',
  TIME_MAGIC = 'Time Magic',
  ONYX_RUNIC = 'Onyx Runic',
  ONYX_TIME_MAGIC = 'Onyx Time Magic',
}

export enum Headwears {
  CORDUROY_CAP = 'Corduroy Cap',
  UNAGI_CAP = 'Unagi Cap',
  BRIMLESS_BEANIE = 'Brimless Beanie',
  PRISMATIC_BUCKET_HAT = 'Prismatic Bucket Hat',
  CAT_ON_HAT = 'Cat on hat?!',
  DENIM = 'Denim',
  BUCKET_HAT_BEACH = 'Bucket Hat Beach',
  POETIC_HAT = 'Poetic Hat',
  HEADBAND = 'Headband',
  FLOWER = 'Flower',
  INVERTED_CAP = 'Inverted Cap',
  PRISMATIC_HEADPHONES = 'Prismatic Headphones',
  STRAW_HAT = 'Straw Hat',
  BACKWARD_CAP = 'Backward Cap',
  PANEL_CAP = 'Panel Cap',
  STAR_HEADPHONES = 'Star Headphones',
  FLOWER_CROWN = 'Flower Crown',
  BIG_BOW = 'Big Bow',
  JOJO_CAP = 'Jojo Cap',
  MOON_TIARA = 'Moon Tiara',
  BERET_BLACK = 'Beret Black',
  WHITE_BOW = 'White Bow',
  PAPER_BOY = 'Paper Boy',
  BUCKET_HAT_PERSONA = 'Bucket Hat Persona',
  BEANIE = 'Beanie',
  FOREST_SPIRIT = 'Forest Spirit',
  MAGIC_KNIGHT = 'Magic Knight',
  PRISMATIC_BOW = 'Prismatic Bow',
  SNAPBACK_BASKETBALL = 'Snapback Basketball',
  YELLOW_BOW = 'Yellow Bow',
  FERAL_SPIRIT = 'Feral Spirit',
  DRAGON_CROWN_GOLD = 'Dragon Crown Gold',
  PRISMATIC_INVERTED_CAP = 'Prismatic Inverted Cap',
  RETRO_HEADPHONES = 'Retro Headphones',
  ZODIAC = 'Zodiac',
  TSUBA_CAP = 'Tsuba Cap',
  GUNDAM = 'Gundam',
  PERSONA_CORP = 'Persona Corp',
  NERV = 'NERV',
}

export enum Face {
  FRECKLES = 'Freckles',
  KENSHIN = 'Kenshin',
  EYE_SCAR = 'Eye Scar',
  SCAR_THROUGH = 'Scar through',
  BLUSH = 'Blush',
  BEAUTY_MARK = 'Beauty Mark',
  ARTIST = 'Artist',
  KURORO = 'Kuroro',
  HEART = 'Heart',
  YAMCHA = 'Yamcha',
  LUFFY = 'Luffy',
  YUJI = 'Yuji',
  BLACK_MARKS = 'Black marks',
}

export enum Eyewear {
  RETRO_RED = 'Retro Red',
  READING_VINTAGE = 'Reading Vintage',
  HEART = 'Heart',
  YUSUKE = 'Yusuke',
  VINTAGE_BROWN = 'Vintage Brown',
  CLUB_RED = 'Club Red',
  READING_ROUND = 'Reading Round',
  BLUE_VISOR = 'Blue Visor',
  READING_SQUARE = 'Reading Square',
  VINTAGE_OAK = 'Vintage Oak',
  THREE_D = '3D',
  NERDY = 'Nerdy',
  PRISMATIC_VISOR = 'Prismatic Visor',
  ARCADE = 'Arcade',
  KILLER = 'Killer',
  MISATO = 'Misato',
  PRISMATIC_NERDY = 'Prismatic Nerdy',
  RETRO_FACE_SHIELD = 'Retro Face Shield',
  FASHION_RED = 'Fashion Red',
  RETRO_CIRCLE_GOLD = 'Retro Circle Gold',
  VINTAGE_BLACK = 'Vintage Black',
  FASHION_BLUE = 'Fashion Blue',
  MYSTIC_MASK = 'Mystic Mask',
  VASH = 'Vash',
}

export enum Aura {
  SAKURA = 'Sakura',
  TIME_MAGIC = 'Time Magic',
  RUNES = 'Runes',
}

export enum Friends {
  RED_PANDA_FROST = 'Red Panda: Frost',
  FOX_PRISMATIC_SPIRIT = 'Fox: Prismatic Spirit',
  BIRD_PRISMATIC_SPIRIT = 'Bird: Prismatic Spirit',
  CAT_PRISMATIC_SPIRIT = 'Cat: Prismatic Spirit',
  FOX_HIKARU = 'Fox: Hikaru',
  FOX_AKIRA = 'Fox: Akira',
  BIRD_ROBYN = 'Bird: Robyn',
  RED_PANDA_PRISMATIC_SPIRIT = 'Red Panda: Prismatic Spirit',
  RED_PANDA_AMBER = 'Red Panda: Amber',
  RED_PANDA_OREO = 'Red Panda: Oreo',
  FOX_JET = 'Fox: Jet',
  FOX_YUKI = 'Fox: Yuki',
  CAT_BISCUIT = 'Cat: Biscuit',
  BABY_SHENRON = 'Baby Shenron',
  CAT_SHADOW = 'Cat: Shadow',
  FOX_MARU = 'Fox: Maru',
  RED_PANDA_SHADOW = 'Red Panda: Shadow',
  RED_PANDA_BLAZE = 'Red Panda: Blaze',
  CAT_TIGER = 'Cat: Tiger',
  CAT_SPECTER = 'Cat: Specter',
  FOX_KIKO = 'Fox: Kiko',
  BIRD_SLATE = 'Bird: Slate',
  BIRD_COBALT = 'Bird: Cobalt',
  BIRD_WHEATLEY = 'Bird: Wheatley',
  BABY_SHENRON_PRISMATIC = 'Baby Shenron Prismatic',
  BIRD_AMBER = 'Bird: Amber',
  FOX_MOCHI = 'Fox: Mochi',
  BIRD_CANARY = 'Bird: Canary',
  BIRD_RUBY = 'Bird: Ruby',
  CAT_SANDY = 'Cat: Sandy',
  FOX_TAMA = 'Fox: Tama',
  CAT_CESAR = 'Cat: Cesar',
}

export enum Neck {
  SILVER_BEADED = 'Silver Beaded',
  PERSONA_LOVE = 'Persona Love',
  BLACK_BEADED = 'Black Beaded',
  HEART = 'Heart',
  MOON_CRESCENT = 'Moon Crescent',
  BLACK_CHOKER = 'Black Choker',
  GEAR = 'Gear',
  CROSS = 'Cross',
  SILVER_CHAIN = 'Silver Chain',
  SNAKE = 'Snake',
  RETRO_HEADPHONES = 'Retro headphones',
  NAMI_MANDARINAS = 'Nami Mandarinas',
  YUSUKE = 'Yusuke',
  GOLD_CHOKER = 'Gold Choker',
  YIN_YANG = 'Yin Yang',
  NINETIES_CHOKER = '90s Choker',
  TIME_MAGIC = 'Time Magic',
  GOKU_STARS = 'Goku Stars',
  BLACK_PENDANT = 'Black Pendant',
  STAR_MOON = 'Star Moon',
  LAYERED_CHAIN = 'Layered Chain',
  TAMAGOSHI = 'Tamagoshi',
  PERSONA = 'Persona',
  MISATO = 'Misato',
}

export enum Earrings {
  CROSS = 'Cross',
  VINTAGE_MIX = 'Vintage mix',
  POTARA = 'Potara',
  CRYSTAL_EARRING = 'Crystal Earring',
  KURORO = 'Kuroro',
  EMOJI_GIRL = 'Emoji Girl',
  MOON_CRESCENT = 'Moon Crescent',
  POTARA_SINGLE = 'Potara Single',
  DOUBLE_FEATHER = 'Double Feather',
  LENNY = 'Lenny',
  BEADS = 'Beads',
  BAMBOO = 'Bamboo',
  POKE = 'Poke',
  PRISMATIC_LOOPS = 'Prismatic Loops',
  EMOJI_BOY = 'Emoji Boy',
  DOUBLE_LOOP = 'Double Loop',
  HEXAGONAL = 'Hexagonal',
  VISIO = 'Visio',
  ROUND_SILVER = 'Round Silver',
  SQUARE = 'Square',
  DOUBLE_HELLIX = 'Double Hellix',
  PACMAN = 'Pacman',
  MULTI_CHAIN = 'Multi Chain',
  GOLD_HOOP = 'Gold Hoop',
  TIME_MAGIC_LONG = 'Time Magic long',
  TIME_MAGIC_SHORT = 'Time Magic short',
  PERSONA_GOLD = 'Persona Gold',
  PRISMATIC_RINGS = 'Prismatic rings',
  CIRCLE_EARRING = 'Circle earring',
  HOOPS = 'Hoops',
  FLAME = 'Flame',
  YIN_YANG = 'Yin Yang',
  PEACE = 'Peace',
  PEARLS = 'Pearls',
  EAR_PIERCE = 'Ear Pierce',
}

export enum Back {
  SHINAI_SWORD = 'Shinai Sword',
  POWER_POLE = 'Power Pole',
  REK_SWORD = 'Rek Sword',
  BACK_TRAINING_STICK = 'Back Training Stick',
  FUTURE_TRUNKS_SWORD = 'Future Trunks Sword',
  DOUBLE_BACK_SWORDS = 'Double Back Swords',
}

export enum Council {
  COUNCILOR = 'Councilor',
  PRISM_MASTER = 'Prism Master',
  TIME_MASTER = 'Time Master',
}

export enum Trait {
  RARITY = 'Rarity',
  GENDER = 'Gender',
  BACKGROUND = 'Background',
  AURA = 'Aura',
  BACK = 'Back',
  CLOTHING = 'Clothing',
  COUNCIL = 'Council',
  EARRINGS = 'Earrings',
  EYES = 'Eyes',
  EYEWEAR = 'Eyewear',
  FACE = 'Face',
  FRIENDS = 'Friends',
  HAIRCUTS = 'Haircuts',
  HEADWEARS = 'Headwears',
  MOUTH = 'Mouth',
  NECK = 'Neck',
  TYPE = 'Type',
}

export const TraitValues = {
  [Trait.GENDER]: Object.values(Gender),
  [Trait.BACKGROUND]: Object.values(Background),
  [Trait.AURA]: Object.values(Aura),
  [Trait.BACK]: Object.values(Back),
  [Trait.CLOTHING]: Object.values(Clothing),
  [Trait.COUNCIL]: Object.values(Council),
  [Trait.EARRINGS]: Object.values(Earrings),
  [Trait.EYES]: Object.values(Eyes),
  [Trait.EYEWEAR]: Object.values(Eyewear),
  [Trait.FACE]: Object.values(Face),
  [Trait.FRIENDS]: Object.values(Friends),
  [Trait.HAIRCUTS]: Object.values(Haircuts),
  [Trait.HEADWEARS]: Object.values(Headwears),
  [Trait.MOUTH]: Object.values(Mouth),
  [Trait.NECK]: Object.values(Neck),
  [Trait.TYPE]: Object.values(Type),
};
